import { tv } from 'tailwind-variants';

const styles = tv({
  base: `
      overflow-hidden
      rounded-3xl
      bg-gray-200
      after:block
      after:h-full
      after:w-[--percentage]
      after:rounded-3xl
      after:bg-[#EA7315]
      after:content-['']
  `,
  variants: {
    size: {
      sm: `
        h-2
        w-32
      `,
      md: `
        h-5
        w-full
        md:w-64
      `,
    },
  },
  defaultVariants: {
    size: 'md',
  },
});

export default styles;
